// extracted by mini-css-extract-plugin
export default {"header":"_96VXj","closeButton":"_1Z-ue","title":"zdBga","selectButton":"s0AMT"};